module.exports = __webpack_public_path__ + "static/media/LogoAppstore2.ab7f763f.png";